import { useDispatch, useSelector } from 'react-redux'
import { selectHomeData, selectIsEditingSpeedFormation } from '@/containers/HomePage/HomeSelectors'
import { setIsEditingSpeedFormation, setSpeedFormationDate } from '@/containers/HomePage/HomeSlice'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { hasSpeedFormationDueDate } from '@/containers/HomePage/SpeedFormation/hasSpeedFormationDueDate'

const useSpeedFormation = () => {
  const dispatch = useDispatch()
  const { speedFormation, isAdmin } = useSelector(selectHomeData)
  const isEditing = useSelector(selectIsEditingSpeedFormation)
  const { country } = useSelector(selectAuthData)

  const setIsEditing = value => {
    if (value) {
      dispatch(setSpeedFormationDate(speedFormation?.date ?? null))
    }
    dispatch(setIsEditingSpeedFormation(value))
  }

  return { speedFormation, isAdmin, isEditing, setIsEditing, hasDueDate: hasSpeedFormationDueDate(country) }
}

export default useSpeedFormation
